import { obterUnidadesAdmAsync } from "../../services/unidadeAdmService";

const atualizarUnidadesAdm = async ({ commit }) => {
    const unidadesAdm = await obterUnidadesAdmAsync();
    commit('atualizarUnidadesAdm', unidadesAdm);
}

const atualizarUnidadeAdm = ({ commit }, unidadeAdm) => {
    commit('atualizarUnidadeAdm', unidadeAdm);
}

export default {
    atualizarUnidadesAdm,
    atualizarUnidadeAdm
}